import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Return } from 'src/models/requestModels/returns/return';

@Injectable({
  providedIn: 'root'
})
export class ReturnService {

  constructor() { }

  private defaultReturnInfo : Return = {
    reason: '',
    iban: '',
    bank: '',
    name: '',
    cartLines: {}
  };

  private _returnInfo = new BehaviorSubject<Return>(this.defaultReturnInfo);

  public readonly returnInfo$ = this._returnInfo.asObservable();

  get returnInfo() {
    return this._returnInfo.getValue();
  }

  set returnInfo(value: Return) {
    this._returnInfo.next(value);
  }

  addNewOrderInfo(value: Return) {
    this.returnInfo = {...value};
  } 

  removeOrderInfo() {
    this.returnInfo = this.defaultReturnInfo;
  }
}
